import * as moment from "moment";
import * as XLSX from 'xlsx';
import { Enum } from "@common/enums/enum";
import { ISubscriptionPlanInput } from '@common/models/subscription/subscription-plan.model';
import { dashboardChartFilterEnum } from "@common/enums/dashboard-chart-filter.enum";
import { environment } from "src/environments/environment";
import { CustomerIdentityKeyEnum, ProductIdentityKeyEnum } from "@common/enums/company-setting.enum"
import { io } from "socket.io-client";
import { OrderDetail } from "@common/models/general/order.model";
import { DiscountType } from "@common/enums/discount-type.enum";
import { IGetRowsParams } from "ag-grid-community/dist/lib/interfaces/iDatasource";
import { FilterForSaleReturnScreen } from "@common/interface/customFilterForSaleReturnScreen";
import { source } from "@common/enums/source.enum";
import { subscriptionTenureType } from "@common/enums/susbcription-tenure-type.enum";
import { paymentStatusEnum } from "@common/enums/payment-status.enum";


export async function getKeyValueByEnum(obj: any) {
  const arr = [];
  let enumFilter = Object.keys(obj)
    .filter(key => isNaN(Number(key)))
    .map(key => obj[key])
    .filter(val => typeof val === "number" || typeof val === "string");

  enumFilter.forEach(element => {
    arr.push({ Id: element, stxt: element })
  });
  return arr;
}

export function getEnumKeyByValue(selectedEnum: any, selectedVal: number) {
  let keys = Object.keys(selectedEnum).filter((x) => selectedEnum[x] == selectedVal);
  return keys.length > 0 ? keys[0] : '';
}

export function getEnumValueByKey(selectedEnum: any, selectedKey: string) {
  return Object.entries(selectedEnum).find(([key, val]) => key === selectedKey)?.[1];
}

export function currencyFormatter(value, decimalPlaces = 0) {

  const formattedValue = Number(value??0)?.toFixed(decimalPlaces);
  return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getSubscriptionEndDate(plan: ISubscriptionPlanInput, qty: number, endDate: Date = new Date()) {


  switch (plan.tenureType.toString()) {
    case subscriptionTenureType.days:
      endDate = moment(endDate).add(Number(plan.tenure) * qty, 'days').toDate();
      break;
    case subscriptionTenureType.weeks:
      endDate = moment(endDate).add(Number(plan.tenure) * qty, 'weeks').toDate();
      break;
    case subscriptionTenureType.months:
      endDate = moment(endDate).add(Number(plan.tenure) * qty, 'months').toDate();
      break;
    case subscriptionTenureType.years:
      endDate = moment(endDate).add(Number(plan.tenure) * qty, 'years').toDate();
      break;
  }

  return endDate;
}

export function agFilters(agParams: any, searchText: string, customFilters) {

  return JSON.stringify({ startRow: agParams?.startRow, endRow: agParams?.endRow, searchText: searchText, sortModel: agParams?.sortModel, filterModel: agParams?.filterModel, customFilters: customFilters })
}

export function exportExcel(data: any, fileName: any) {

  if (data?.length > 0) {

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName);
  }
  else if (data == '') {

    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName);
  }
}


export function getFilterDuration(filterType: number) {

  let startDate = moment();
  let endDate = moment();

  switch (filterType) {
    case dashboardChartFilterEnum.ThisWeek: //This Week
      startDate = moment().weekday(1)
      break;
    case dashboardChartFilterEnum.ThisMonth: //This Month
      startDate = moment().startOf('month')
      break;
    case dashboardChartFilterEnum.LastWeek: //Last Week
      startDate = moment().weekday(1).subtract(7, 'days')
      endDate = moment().weekday(1).subtract(7, 'days').endOf('isoWeek')
      break;
    case dashboardChartFilterEnum.LastMonth: //Last Month
      startDate = moment().startOf('month').subtract(1, 'months')
      endDate = moment().startOf('month').subtract(1, 'months').endOf('month')
      break;

  }

  return [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')]

}


export function getObjectKeys(obj: any): string[] {
  return Object.keys(obj);
}

export function getCurrentFormatedDate() {

  const date = new Date();
  const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const formattedDate = formatter.format(date);

  return formattedDate;
}

export function getCurrentTime() {
  try {

    const currentTime = new Date();
    let currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    const amOrPm = currentHours >= 12 ? "PM" : "AM";

    // Convert hours to 12-hour format
    currentHours = currentHours % 12 || 12;

    const currentHoursStr = currentHours.toString().padStart(2, '0');
    const currentMinutesStr = currentMinutes.toString().padStart(2, '0');

    return ` ${currentHoursStr}:${currentMinutesStr} ${amOrPm}`;

  } catch (err) {
    console.log(err);
  }
}

export const showNoRecordsOverlay = (count: number, options: any) => {

  if (count > 0) {
    options.api.hideOverlay();
  } else {
    options.suppressNoRowsOverlay = false;
    options.api.showNoRowsOverlay();
  }

}

export function dateChecker(event: Date, date: string, fromDateValue?: any, toDateValue?: any) {
  const toDateFilterError = date === Enum.DateRangeType.to
    ? moment(fromDateValue).format('YYYY-MM-DD') <= moment(event).format('YYYY-MM-DD') ? '' : 'To date must be greater than From date'
    : '';
  const fromDateFilterError = date === Enum.DateRangeType.from
    ? moment(toDateValue).format('YYYY-MM-DD') >= moment(event).format('YYYY-MM-DD') ? '' : 'From date must be less than To date'
    : '';
  const disabled = (date === Enum.DateRangeType.to && moment(fromDateValue).format('YYYY-MM-DD') > moment(event).format('YYYY-MM-DD')) ||
    (date === Enum.DateRangeType.from && moment(toDateValue).format('YYYY-MM-DD') < moment(event).format('YYYY-MM-DD'));

  return {
    toDateFilterError,
    fromDateFilterError,
    disabled,
  };
}

export function getOrderDetailPageURL(actionArgs) {
  try {

    let data;
    if (actionArgs?.data) {
      data = actionArgs?.data;
    } else {
      data = actionArgs;
    }

    const queryParams = { orderId: data?.orderId };
    const queryString = Object.keys(queryParams).map(key => key + '=' + queryParams[key]).join('&');
    const url = '/app/orders/orders-detail?' + queryString;
    return url;

  } catch (error) {
    console.log(error);
  }
}

export function setFilterRequest(agParams: IGetRowsParams, searchText: string, customFilters: FilterForSaleReturnScreen) {

  return JSON.stringify({ startRow: agParams?.startRow, endRow: agParams?.endRow, searchText: searchText, sortModel: agParams?.sortModel, customFilters: customFilters, filterModel: agParams?.filterModel })
}

export function getHyperLinkTag(params) {
  try {

    return `<u><a style="color: blue" target="_blank" href="${getOrderDetailPageURL(params?.data)}">${params?.value}</a><u>`;

  } catch (error) {
    console.log(error);
  }
}

export function calculateDiscount(discountType: number, discountAmount: number = 0, totalQuantity: number, price: number, updatedQuantity?: number) {
  try {
    var decimalLimit = JSON.parse(localStorage.getItem('decimalPointLimit'));
    if (discountType === DiscountType.Percent) {

      let newDiscount = discountAmount / totalQuantity;
      if (updatedQuantity) { 
        newDiscount = newDiscount * updatedQuantity
      }
      
      let perDiscount = (newDiscount * 100) / (price * totalQuantity)
      perDiscount = Number(perDiscount.toFixed(decimalLimit));
      newDiscount = Number(newDiscount.toFixed(decimalLimit));
      return { discountInAmount: 0, discountInPercent: perDiscount, discountAmount: newDiscount }

    } else {

      let newDiscount = discountAmount / totalQuantity;
      if (updatedQuantity) { 
        newDiscount = newDiscount * updatedQuantity 
      }
      
      newDiscount = Number(newDiscount.toFixed(decimalLimit));
      return { discountInAmount: newDiscount, discountInPercent: 0, discountAmount: newDiscount }
    }
  } catch (error) {
    console.log(error);
  }
}

export function reasonTagFilter(agParams: IGetRowsParams) {

  return JSON.stringify({ startRow: agParams?.startRow, endRow: agParams?.endRow, sortModel: agParams?.sortModel })
}

export function checkCustomerIdentityKeyValue(email: any, phone: any, customerIdentityKey: number) {

  try {
    let flag: boolean;
    let message: string;

    switch (customerIdentityKey) {
      case CustomerIdentityKeyEnum.AnyOne:
        flag = email || phone;
        message = flag ? null : `Kindly fill in either the phone number or email before updating an order.`;
        break;

      case CustomerIdentityKeyEnum.Email:
        flag = !!email;
        message = flag ? null : `Kindly fill in email before updating an order.`;
        break;

      case CustomerIdentityKeyEnum.ContactNumber:
        flag = !!phone;
        message = flag ? null : `Kindly fill in phone number before updating an order.`;
        break;

      case CustomerIdentityKeyEnum.Both:
        flag = phone && email;
        message = flag ? null : `Kindly fill in phone number and email before updating an order.`;
        break;
    }

    return { message, flag };

  } catch (error) {
    console.log(error);
  }
}

export function dailyOrderActivityDetailReportFilters(agParams: IGetRowsParams, customFilters: FilterForSaleReturnScreen) {
  return JSON.stringify({ startRow: agParams?.startRow, endRow: agParams?.endRow,sortModel: agParams?.sortModel, customFilters: customFilters })
}

// export function getSocketIOConnection() {

//   let socket;
//   try {

//     let baseURL = environment.apiUrl.replace("/api", "");
//     socket = io(baseURL, {
//       path: environment.socketIOPath,
//     });

//   } catch (error) {
//     console.log(error);
//   }
//   return socket;
// }

export function sanitizeNumberValue(value): number {

  let val = typeof value === 'string' ? value.replace(/[^\d.]/g, '') : value;
  return val === '' ? 0 :  Number(val);
}

export function warehouseFilter(agParams: IGetRowsParams, searchText: string,) {

  return JSON.stringify({ startRow: agParams?.startRow, endRow: agParams?.endRow, searchText: searchText, sortModel: agParams?.sortModel })
}

export function setDecimalLimit(value: number, limit: number) {
  return value?.toFixed(limit);
}

export function getItemByProductIdentityKey(lineItems: OrderDetail[], detail: OrderDetail, productIdentityKey: number) {

  try {

    let result: OrderDetail;

    switch (productIdentityKey) {

      case ProductIdentityKeyEnum.SKU:

        result = lineItems.find((f) => f.sku === detail.sku);
        break;

      case ProductIdentityKeyEnum.Name:
        result = lineItems.find((f) => f.name === detail.name);
        break;

      default:
        result = lineItems.find((f) => f.sku === detail.sku && f.name === detail.name);

    }

    return result;

  } catch (e) {
    console.log(e);
  }

}

export function categorizeOrders(orders) {
  return {
      darazOrders: orders.filter((x) => x.sellingChannelCode === source.Daraz),
      antiDarazOrders: orders.filter((x) => x.sellingChannelCode !== source.Daraz),
  };
}

export function getUniqueOrdersBySellingChannelConfigurationId(orders) {
  const uniqueIds = [...new Set(orders.map((o) => o.sellingChannelConfigurationId))];
  return uniqueIds.map((id) => orders.filter((o) => o.sellingChannelConfigurationId === id));
}

export function calculateCODAmount(data) {

    let cod = (data?.codAmount) ?? (data?.payment_status == paymentStatusEnum.Paid ? 0 : ((data?.amount) + (data?.deliveryCharges ?? 0)));
    return cod;

}

export function selectRows(aggridInstance, isSelected: boolean, selectedRows) {
  const pageSize = aggridInstance.options.api.paginationGetPageSize();
  const currentPage = aggridInstance.options.api.paginationGetCurrentPage();
  const startRow = currentPage * pageSize;
  const endRow = startRow + pageSize;

  selectedRows = [];
  aggridInstance.options.api.forEachNode((node, index: number) => {
    if (index >= startRow && index < endRow) {
      node.setSelected(!isSelected);
      if (!isSelected) {
        selectedRows.push(node.data);
      }
    }
  });

  isSelected = !isSelected;
  return { isSelected, selectedRows };
}

